import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { ChannelMonitoring } from '../../types/channelPush'
import useStyles from './styles/channelsTableHead.styles'

interface ChannelsTabelHeadProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      channelPushMonitoring: ChannelMonitoring[]
    }>
  >
}

const ChannelsTabelHead: React.FC<ChannelsTabelHeadProps> = ({ refetch }) => {
  const classes = useStyles()

  return (
    <div className={classes.tableHead}>
      <div>{getTranslate('Name')}</div>
      <div>{getTranslate('Adapter Name')}</div>
      <div>{getTranslate('Health Status')}</div>
      <div>{getTranslate('State')}</div>
      <div>{getTranslate('Last Fetched')}</div>
      <div>{getTranslate('Last Sent')}</div>
      <div>
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default ChannelsTabelHead
